import React, { useState } from 'react';
import Page from '../components/Page';
import { useDayBook } from '../controllers/financial.controller';
import { useStoreSettings } from '../controllers/settings.controller';

export default function FinancialDayBookPage() {
  const [fromDate, setFromDate] = useState(new Date().toISOString().slice(0, 10));
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));

  const { data, isLoading } = useDayBook(fromDate, toDate);
  const { storeSettings } = useStoreSettings();

  const handlePeriodChange = (days) => {
    const d = new Date();
    d.setDate(d.getDate() + days);
    const ds = d.toISOString().slice(0,10);
    setFromDate(ds);
    setToDate(ds);
  }

  if(isLoading) return <Page><div className="p-3">Loading...</div></Page>;

  const invoices = data?.invoices || {};
  const payments = data?.payments || [];
  const expenses = data?.expenses || [];
  
  const totalBilled = invoices.total_billed || 0;
  const totalDiscount = invoices.total_discount || 0;
  const totalTax = invoices.total_tax || 0;
  const totalRoundOff = invoices.total_round_off || 0;
  const dueSales = invoices.due_sales || 0;
  
  const netSales = totalBilled - totalTax + totalDiscount - totalRoundOff;
  const grossSales = netSales + totalDiscount;

  let totalCollected = 0;
  payments.forEach(p => totalCollected += parseFloat(p.total || 0));

  return (
    <Page>
      <div className="container-xl">
        <div className="page-header d-print-none text-white">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Day Book</h2>
            </div>
          </div>
        </div>

        <div className="page-body">
          <div className="card mb-3 d-print-none">
            <div className="card-body">
              <div className="d-flex align-items-center gap-3">
                <button className="btn btn-outline-primary" onClick={() => handlePeriodChange(0)}>Today</button>
                <button className="btn btn-outline-primary" onClick={() => handlePeriodChange(-1)}>Yesterday</button>
                
                <div className="d-flex align-items-center gap-2">
                  <label>From:</label>
                  <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                </div>
                <div className="d-flex align-items-center gap-2">
                  <label>To:</label>
                  <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} />
                </div>
                <button className="btn btn-primary" onClick={() => window.print()}>Print / Export</button>
              </div>
            </div>
          </div>

          <div className="card p-4">
            <div className="text-center mb-4">
              <h1 className="mb-1">{storeSettings?.store_name || 'Restaurant'}</h1>
              <div>Location: {storeSettings?.store_address || ''}</div>
              <div>Phone: {storeSettings?.store_phone || ''}</div>
              {storeSettings?.tax_number && <div>PAN/VAT: {storeSettings.tax_number}</div>}
              <div className="mt-2 fw-bold">Period: {fromDate} {fromDate !== toDate ? 'to ' + toDate : ''}</div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <h3 className="border-bottom pb-2">SALES SUMMARY</h3>
                <table className="table table-sm table-borderless">
                  <tbody>
                    <tr><td>Gross Sales</td><td className="text-end">NPR {grossSales.toFixed(2)}</td></tr>
                    <tr><td>Discount</td><td className="text-end text-danger">-NPR {totalDiscount.toFixed(2)}</td></tr>
                    <tr><td>Net Sales</td><td className="text-end fw-bold">NPR {netSales.toFixed(2)}</td></tr>
                    <tr><td>VAT / Tax</td><td className="text-end">NPR {totalTax.toFixed(2)}</td></tr>
                    <tr><td>Round Off</td><td className="text-end">-NPR {totalRoundOff.toFixed(2)}</td></tr>
                    <tr className="border-top"><td className="fw-bold">Total Billed</td><td className="text-end fw-bold">NPR {totalBilled.toFixed(2)}</td></tr>
                  </tbody>
                </table>
              </div>
              
              <div className="col-md-6">
                <h3 className="border-bottom pb-2">COLLECTION SUMMARY</h3>
                <table className="table table-sm table-borderless">
                  <tbody>
                    {payments.map(p => (
                      <tr key={p.payment_method}>
                        <td>{p.payment_method}</td>
                        <td className="text-end">NPR {parseFloat(p.total).toFixed(2)}</td>
                      </tr>
                    ))}
                    {payments.length === 0 && <tr><td colSpan="2" className="text-muted">No collections</td></tr>}
                    <tr className="border-top"><td className="fw-bold">Total Collected</td><td className="text-end fw-bold">NPR {totalCollected.toFixed(2)}</td></tr>
                    <tr><td>Sales Due</td><td className="text-end">NPR {dueSales.toFixed(2)}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-6">
                <h3 className="border-bottom pb-2">CASH FLOW</h3>
                <table className="table table-sm table-borderless">
                  <tbody>
                    <tr><td>Total Cash In</td><td className="text-end">NPR {(payments.find(p=>p.payment_method==='Cash')?.total || 0).toFixed(2)}</td></tr>
                    <tr><td>Total Cash Out (Expenses)</td><td className="text-end">NPR {(expenses.find(p=>p.payment_method==='Cash')?.total || 0).toFixed(2)}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </Page>
  );
}
